import { render, staticRenderFns } from "./AddressEditing.vue?vue&type=template&id=bffe4b20"
import script from "./AddressEditing.vue?vue&type=script&lang=js"
export * from "./AddressEditing.vue?vue&type=script&lang=js"
import style0 from "./AddressEditing.vue?vue&type=style&index=0&id=bffe4b20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports